import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {ILabel} from '../ILabel.model';
import {AbstractControl, AbstractControlDirective, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ValueAccessorBase} from '../value-accessor-base';
import {CpqSystemIdService} from './cpq-system-id.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'cpq-setup-cpq-system-id',
    templateUrl: './cpq-system-id.component.html',
    styleUrls: ['./cpq-system-id.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CpqSystemIdComponent,
            multi: true
        }
    ],
    standalone: false
})
export class CpqSystemIdComponent extends ValueAccessorBase<string> implements OnChanges, OnInit {
  @Input('control') control: AbstractControlDirective | AbstractControl;
  @Input('modelName') modelName: string;
  @Input('isNew') isNew = false;
  @Input('url') url: string;
  @Input('apiParameter') apiParameter: string;
  @Input('useSapStandardApi') useSapStandardApi: boolean;
  @Input('infoMessage') infoMessage?: ILabel;
  @Input('hideLabel') hideLabel?: boolean = false;
  @Input('iconAlert') iconAlert?: boolean = false;
  @Input('hideRequiredLabel') hideRequiredLabel?: boolean = false;
  @Output('onInfoClick') onInfoClick = new EventEmitter<any>();
  @Output('onChange') onChange = new EventEmitter<string>();
  @Input('readOnly') readOnly = false;
  @Input('cpqNoWhiteSpace') cpqNoWhiteSpace = false;
  @Input('label') label = 'ActionsEdit.SystemID';

  public editingMode: boolean;
  private modelNameObserver: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  constructor(private cpqSystemIdService: CpqSystemIdService) {
    super();
  }

  ngModelChange(value) {
    this.onChange.emit(value);
  }

  ngOnInit() {
    this.modelNameObserver.pipe(debounceTime(300), distinctUntilChanged()).subscribe((modelName: string) => {
      if (modelName) {
        this.getSystemId();
      }
    });
  }

  ngOnChanges() {
    this.modelNameObserver.next(this.modelName);
  }

  public toggleEditSystemId() {
    this.editingMode = !this.editingMode;
    this.getSystemId();
  }

  public getSystemId() {
    if (this.modelName && this.isNew && !this.editingMode) {
      if (this.useSapStandardApi){
        this.cpqSystemIdService.getSystemIdStandardApi(this.url, this.modelName, this.apiParameter).subscribe(systemId => {
          this.value = systemId;
        });
      } else{
        this.cpqSystemIdService.getSystemId(this.url, this.modelName).subscribe(systemId => {
          this.value = systemId;
        });
      }
    }
  }

  infoClicked() {
    this.onInfoClick.emit();
  }
}
